<template>
  <div id="blog">

    <div class="message_bar" v-show="messageShow > 0">
      <div v-show="messageShow == 1">
        <p class="loading" style="padding-top:15px;">Loading</p>
        <img src="@/assets/img/loading_new.gif" alt="loading">
      </div>
      <p style="padding: 10px;" v-show="messageShow == 2">{{message}}</p>
    </div>
    <div class="archive_blogs" ref="archive_blogs" v-show="messageShow == 0">
      <div class="blog_container">
        <template v-for="m in blogList">
          <div class="blog" @click="readBlog(m.hashID)">
            <div class="blog_right">
              <div class="bkg_image" :style="{backgroundImage: `url(${m.headThumb})`}"></div>
            </div>
            <div class="blog_left">
              <div class="blog_info">
                <div class="color_bar">
                  <h2>{{m.title}}</h2>
                  <p>{{m.intro}}</p>
                  <p class="date">{{new Date(m.date).toLocaleDateString("zh")}}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="loader_bar" v-show="isLoading">
      <p class="loading">Loading</p>
      <img src="@/assets/img/loading_new.gif" alt="loading">
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
      infinite-scroll-distance="130" class="scroll_div"></div>

  </div>
</template>

<script>
export default {
  name: 'blog',
  data () {
    return {
      page: 1,
      busy: true,
      isLoading: false,
      messageShow: 1,
      message: '',
      blogList: [],
    }
  },
  methods: {
  },
  created: function () {
    this.$store.dispatch('changeIndex', {linkName: 'blog'});
    this.$store.dispatch('isLogin')
      .then(() => {
        let getBlog = this.$store.getters.getBlog;
        if (getBlog) {
          this.page = getBlog.page;
          this.blogList = getBlog.blogList;
          this.messageShow = 0;
          if (getBlog.isAll) {
            this.busy = true;
            this.isLoading = false;
          } else {
            this.busy = false;
            this.isLoading = true;
          }
        } else {
          this.listBlog();
        }
      })
      .catch((err) => {
        this.messageShow = 2;
        this.message = `[Error] ${err.message}`
      })
  },
  methods: {
    listBlog() {
      this.$store.dispatch('post', {
        address: '/api/listBlog',
        postData: {
          page: this.page,
        },
      })
        .then((data) => {
          if (data.status === 'OK') {
            let updateBlog = {
              isAll: false,
              page: this.page,
              blogList: data.blogList,
            }
            this.blogList = this.blogList.concat(data.blogList);
            this.messageShow = 0;
            if (this.blogList.length >= data.total) {
              updateBlog.isAll = true;
              this.isLoading = false;
            } else {
              this.busy = false;
              this.isLoading = true;
            }
            this.$store.dispatch('updateBlog', updateBlog);
          } else {
            this.messageShow = 2;
            this.message = `[Server Error] ${data.message}`
          }
        })
        .catch((err) => {
          this.messageShow = 2;
          this.message = `[Error list] ${err.message}`
        })
    },
    loadMore() {
      this.busy = true;
      this.page++;
      this.listBlog();
    },
    readBlog(id) {
      const link = `/blog/${id}`;
      this.$router.push(link);
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

$font-color: #5E5E5E;
$background-color: #F5F5F5;
$blog-left-color: #EDEDED;

%display {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.message_bar {
  color: $font-color;
  background-color: $background-color;
  position: relative;
  margin: 0px 50px 30px 50px;
  text-align: center;
}
.archive_blogs {
  background-color: $background-color;
  margin: 0px 50px 0px 50px;
}
.blog_container {
  color: $font-color;
  max-width: 780px;
  margin: 0 auto;
  padding: 10px;
}
.blog {
  @extend %display;
  margin: 20px 0;
  min-height: 160px;
  cursor: pointer;
  -ms-flex-direction: row;
  flex-direction: row;
}

.blog_right {
  order: 2;
  width: 50%;
  position: relative;
  overflow-x: hidden;
  .bkg_image {
    height: 100%;
    background: no-repeat 50%;
    background-size: cover;
    overflow-x: hidden;
    width: 100%;
  }
}

.blog_right:after {
  border: 1px solid rgba(0, 0, 0, 0.1);
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.blog_left {
  background-color: $blog-left-color;
  order: 1;
  width: 50%;
  position: relative;
  .blog_info {
    padding: 30px 50px 30px 30px;
    .color_bar {
      padding: 0 0 0 20px;
      border: solid #999999;
      border-width: 0px 0px 0px 4px;
    }
    .date {
      font-size: 0.8em;
      color: #9c9c9c;
      display: flex;
      justify-content: flex-end;
    }
  }
}

.loader_bar {
  color: $font-color;
  background-color: $background-color;
  margin: 0 50px 20px 50px;
  height: auto;
  text-align: center;
}
.loading {
  margin: 0;
  padding-top: 10px;
  font-family: fashionFetish;
  font-weight: 600;
  color: $font-color;
  text-align: center;
  text-transform: uppercase;
  font-size: 9px;
}
.scroll_div {
  height: 30px;
}

@media screen and (max-width: 767px) {
  .blog {
    display: block;
  }
  .blog_right, .blog_left{
    left: 0;
    right: 0;
    width: 100%;
    .blog_info {
      padding: 10px;
    }
  }
  .blog_right .bkg_image {
    height: 200px;
  }
  .message_bar {
    margin: 0px 10px 30px 10px;
  }
  .archive_blogs {
    margin: 10px 10px 0 10px;
  }
  .loader_bar {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blog.vue